import React from 'react';
import ReactDOM from 'react-dom';
import './assets/index.scss';
import App from './views/App';
import {register} from './serviceWorkerRegistration';
import 'moment/locale/pt-br'
import moment from 'moment';
import Highcharts from 'highcharts';


moment.locale('pt-br');

// Highcharts renderiza texto em SVG e não herda a fonte da página — sem
// isso, todo gráfico (SaldoHoras, velocímetro/gauge) cai no fallback padrão
// do Highcharts ("Lucida Grande"/Arial), ignorando o Poppins do resto do app.
Highcharts.setOptions({
    chart: {
        style: {
            fontFamily: '"Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, sans-serif',
        },
    },
});

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
register();
